import React from 'react';
import { COVERAGE_STATS, BOROUGHS, IMAGES } from '../mock';

export default function Coverage() {
  return (
    <section id="coverage" className="relative py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.cityAerial} alt="London aerial" className="w-full h-full object-cover opacity-[0.12]" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg,var(--bg),rgba(9,12,19,0.9))' }} />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-12">
          {/* Left */}
          <div>
            <div className="label-mono text-[var(--accent)] mb-6" data-reveal>Coverage</div>
            <h2 className="font-display text-[clamp(2.4rem,6vw,4.6rem)] text-white" data-reveal>
              All 33<br /><span className="font-display-italic text-[#c3cbdb]">boroughs.</span>
            </h2>
            <p className="mt-8 text-[var(--muted)] text-[15px] leading-relaxed max-w-md" data-reveal data-delay="80">
              From Islington rooftops to Bromley plant rooms — a fleet of vans staged across four depots, so no address is more than 45 minutes from a certified engineer.
            </p>

            <div className="mt-12 grid grid-cols-2 gap-x-10 gap-y-8 max-w-sm" data-reveal data-delay="140">
              {COVERAGE_STATS.map((s) => (
                <div key={s.label} className="border-t border-[var(--line-strong)] pt-3">
                  <div className="font-display text-[clamp(2rem,4vw,2.6rem)] text-white">{s.value}</div>
                  <div className="mt-2 label-mono text-[var(--muted)]">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: borough grid */}
          <div className="border border-[var(--line)] bg-[var(--card)]/60 backdrop-blur-sm p-7 md:p-9" data-reveal data-delay="100">
            <div className="label-mono text-[var(--muted)] mb-7">Live Coverage Grid · Greater London</div>
            <div className="flex flex-wrap gap-2.5">
              {BOROUGHS.map((b) => (
                <span
                  key={b}
                  className="group flex items-center gap-2 border border-[var(--line)] rounded-md px-3 py-2 text-[12.5px] text-[#c3cbdb] hover:border-[var(--accent)] hover:text-white transition-colors cursor-default"
                >
                  <span className="w-1.5 h-1.5 bg-[var(--accent)] group-hover:scale-125 transition-transform" />
                  {b}
                </span>
              ))}
            </div>
            <div className="mt-8 pt-6 border-t border-[var(--line)] flex flex-wrap items-center justify-between gap-3">
              <span className="label-mono text-white">Not in London?</span>
              <span className="label-mono text-[var(--muted)] normal-case tracking-normal text-[12px]">We cover a 25-mile ring from Charing Cross — call to confirm.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
